
















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { autoArchiveOptionsArr, predicateOptions, predicateCn } from '@/config/map.conf';
import * as api from '@/api';
import { Form } from '@ss/mtd-vue';
// import { keys } from 'lodash';

/**
 * rg问题归档
 *
 * @author liyuyao
 * @date 11/07/2020
 */
@Component({
    components: {}
})
export default class RgFileEdit extends Vue {
    @Prop({ default: {} }) node: any;
    @Prop() showEdit: boolean;
    @Prop() rgCloseReasonField: any;
    @Prop() openArchiveCloseReason: boolean;
    autoArchiveOptionsArr: Array<{ value: any; label: string }> = autoArchiveOptionsArr;
    predicateOptions: any = predicateOptions;
    predicateCn: any = predicateCn;
    itemForm: any = {
        itemLogic: 'OR',
        parentId: 0,
        id: 0,
        conditions: [
            {
                fieldName: '',
                fieldPredicate: '',
                fieldValue: '',
                parentId: 0,
                id: 0
            }
        ]
    };
    closeReasonForm: any = {
        contents: [
            {
                closeReasonContent: '',
                closeReasonId: null,
                id: null
            }
        ]
    };
    triggerForm: any = {
        name: '',
        triggerTime: 'ARCHIVE_RECOMMEND',
        scene: 'RG',
        itemLogic: 'OR',
        active: false,
        actions: [],
        activeReason: false
    };
    triggerId: number = 0;
    withErrorArr: boolean[] = [false];
    btnLoading: boolean = false;
    $refs: { itemForm: Form; closeReasonForm: Form };
    activeReasonLoading: boolean = false;
    closeReasonErrorArr: boolean[] = [];
    searchCloseReasonList: any = [];

    @Watch('node', { immediate: true })
    getNodeChanged() {
        this.showEdit && this.node.itemId && this.node.ruleId && this.getTriggerDetail();
        this.showEdit && this.node.itemId && this.getArchiveCloseReasonSetting();
        this.closeReasonErrorArr = [false];
        this.withErrorArr = [false];
    }

    @Watch('rgCloseReasonField', { immediate: true })
    getRgCloseReasonFieldChanged() {
        this.searchCloseReasonList = this.rgCloseReasonField;
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    resetForm() {
        this.itemForm = {
            itemLogic: 'OR',
            parentId: 0,
            id: 0,
            conditions: [
                {
                    fieldName: '',
                    fieldPredicate: '',
                    fieldValue: '',
                    parentId: 0,
                    id: 0
                }
            ]
        };
        this.triggerForm = {
            name: '',
            triggerTime: 'ARCHIVE_RECOMMEND',
            scene: 'RG',
            itemLogic: 'OR',
            active: false,
            actions: [],
            activeReason: false
        };
        this.closeReasonForm = {
            contents: [
                {
                    closeReasonContent: '',
                    closeReasonId: null,
                    id: null
                }
            ]
        };
    }

    async getTriggerDetail() {
        const res = await api.ruleApi.getTriggerDetail(this.node.ruleId);
        const { code, data } = res;
        if (code === 200 && data) {
            const { name, active, actions, conditionGroups } = data;
            this.triggerForm.name = name;
            this.triggerForm.actions = actions;
            this.triggerForm.active = active;
            this.itemForm = conditionGroups[0];
        }
    }

    async autoArchiveChanged(actived: boolean) {
        if (!this.node.inUse) {
            this.$mtd.message.error('问题归档已停用无法开启自动归档');
            this.triggerForm.active = false;
            return;
        }
        if (this.node.ruleId) {
            await api.ruleApi.triggerSwitch(this.node.ruleId, actived);
        }
    }
    async autoArchiveCloseReasonChanged(actived: boolean) {
        // if (!this.node.inUse) {
        //     !actived && await api.ctiApi.archiveSwitch({ rgId: this.rgId, nodeId: this.node.itemId, closeReasonSwitch: 'off' });
        //     this.$mtd.message.error('问题归档已停用无法开启关联关闭原因');
        //     this.triggerForm.activeReason = false;
        //     return;
        // }
        const closeReasonSwitch = actived ? 'on' : 'off';
        await api.ctiApi.archiveSwitch({ rgId: this.rgId, nodeId: this.node.itemId, closeReasonSwitch: closeReasonSwitch });
        this.getArchiveCloseReasonSetting();
        this.closeReasonErrorArr = [false];
    }
    addCondition() {
        if (this.itemForm.conditions.length < 10) {
            this.itemForm.conditions.push({
                fieldName: '',
                fieldPredicate: '',
                fieldValue: ''
            });
            this.withErrorArr.push(false);
        } else {
            this.$mtd.message.error('最多允许添加10个条件');
        }
    }
    addContent() {
        if (this.closeReasonForm.contents.length < 50) {
            this.closeReasonForm.contents.push({
                closeReasonContent: '',
                closeReasonId: null,
                id: null
            });
            this.closeReasonErrorArr.push(false);
        } else {
            this.$mtd.message.error('最多允许添加50个条件');
        }
    }
    deleteCondition(index) {
        this.itemForm.conditions.splice(index, 1);
        this.withErrorArr.splice(index, 1);
    }
    deleteContent(index) {
        this.closeReasonForm.contents.splice(index, 1);
        this.closeReasonErrorArr.splice(index, 1);
    }
    conditionChange(index) {
        this.itemForm.conditions[index].fieldPredicate = '';
        this.itemForm.conditions[index].fieldValue = '';
    }
    contentChange(value, index) {
        const selectedField = this.rgCloseReasonField.find(field => field.content === value);
        if (selectedField) {
            this.closeReasonForm.contents[index].closeReasonContent = selectedField.content;
            this.closeReasonForm.contents[index].closeReasonId = selectedField.id;
            this.closeReasonForm.contents[index].id = selectedField.id;
        } else {
            // 如果找不到匹配的 field，清除相关内容
            this.closeReasonForm.contents[index].closeReasonContent = '';
            this.closeReasonForm.contents[index].closeReasonId = null;
            this.closeReasonForm.contents[index].id = null;
        }
    }
    get formatItemForm() {
        const format: CommonTypes.conditionGroupDo = {
            itemLogic: this.itemForm.itemLogic,
            conditions: this.itemForm.conditions.map(condition => {
                const formatCondition: CommonTypes.conditionDO = {
                    fieldName: condition.fieldName,
                    fieldPredicate: condition.fieldPredicate,
                    fieldValue: condition.fieldValue
                };
                if (!!condition.id) {
                    formatCondition.id = condition.id;
                    formatCondition.parentId = condition.parentId;
                }
                return formatCondition;
            })
        };
        if (!!this.itemForm.id) {
            format.id = this.itemForm.id;
            format.parentId = this.itemForm.parentId;
        }
        return format;
    }
    async submit() {
        // 验证 itemForm 和 closeReasonForm
        let itemFormValid = true;
        this.triggerForm.active &&
            (await this.$refs.itemForm?.validate(valid => {
                itemFormValid = valid;
            }));
        let closeReasonFormValid = true;
        // 同时开启关联关闭原因总开关和子开关时，验证 closeReasonForm
        this.openArchiveCloseReason &&
            this.triggerForm.activeReason &&
            (await this.$refs.closeReasonForm?.validate(valid => {
                closeReasonFormValid = valid;
            }));
        const formError = this.triggerForm.active ? this.formError : false;
        const closeReasonFormError = this.openArchiveCloseReason && this.triggerForm.activeReason ? this.closeReasonFormError : false;

        if (itemFormValid && !formError && closeReasonFormValid && !closeReasonFormError) {
            if (this.triggerForm.active) {
                const submitForm: CommonTypes.triggerForm = {
                    name: this.triggerForm.name || this.node.nodeName,
                    scene: this.triggerForm.scene,
                    sceneId: this.rgId,
                    active: this.triggerForm.active,
                    triggerTime: this.triggerForm.triggerTime,
                    conditionGroups: [this.formatItemForm],
                    actions: this.triggerForm.actions,
                    itemLogic: this.triggerForm.itemLogic,
                    sequence: this.node.depth
                };
                if (this.node.ruleId) {
                    // 更新触发器
                    submitForm.id = this.node.ruleId;
                } else {
                    // 新增触发器
                    submitForm.actions = [
                        {
                            fieldName: 'ARCHIVE',
                            fieldAction: 'UPDATE',
                            fieldValue: this.node.itemId.toString(),
                            parentScene: 1
                        }
                    ];
                    submitForm.name = '问题归档-' + submitForm.name;
                }
                const res = this.node.ruleId
                    ? await api.ruleApi.updateTrigger(this.node.ruleId, submitForm)
                    : await api.ruleApi.createTrigger(submitForm);
                const { code, data } = res;
                if (code === 200 && data) {
                    this.$mtd.message.success('自动归档条件保存成功');
                    if (!this.node.ruleId) {
                        this.$emit('update', data);
                    }
                }
            }
            if (this.triggerForm.activeReason && this.openArchiveCloseReason) {
                this.submitArchiveCloseReason();
            }
        }
    }

    get formError() {
        this.itemForm.conditions.forEach((condition, index) => {
            const validate = (condition.fieldName && condition.fieldPredicate && condition.fieldValue) || false;
            this.$set(this.withErrorArr, index, !validate);
        });
        const hasArror = this.withErrorArr.find(error => {
            return error === true;
        });
        return hasArror;
    }

    get closeReasonFormError() {
        let hasError = false;
        this.closeReasonErrorArr = this.closeReasonForm?.contents?.map(content => {
            const validate = content?.closeReasonContent || false;
            if (!validate) {
                hasError = true;
            }
            return !validate;
        });
        return hasError;
    }

    async getArchiveCloseReasonSetting() {
        this.activeReasonLoading = true;
        const res = await api.ctiApi.getArchiveCloseReasonSetting({ rgId: this.rgId, nodeId: this.node.itemId });
        const { code, data } = res;
        if (code === 200 && data) {
            this.triggerForm.activeReason = data?.closeReasonSwitch === 'on';
            this.closeReasonForm.contents =
                data?.archiveCloseReasonDOList?.length > 0
                    ? data?.archiveCloseReasonDOList
                    : [
                          {
                              closeReasonContent: '',
                              closeReasonId: null,
                              id: null
                          }
                      ];
        }
        this.activeReasonLoading = false;
    }

    async submitArchiveCloseReason() {
        // 提取 id 构成 closeReasonIdList
        const closeReasonIdList = this.closeReasonForm?.contents?.map(content => content.closeReasonId);
        const res = await api.ctiApi.saveArchiveCloseReason({ rgId: this.rgId, nodeId: this.node.itemId, closeReasonIdList: closeReasonIdList });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('关联关闭原因保存成功');
            this.getArchiveCloseReasonSetting();
        }
    }

    async searchCloseReason(keyword) {
        keyword = keyword || '';
        const res = await api.ctiApi.searchCloseReason({ type: 'CLOSED_REASON', rgId: this.rgId, keyword: keyword });
        const { code, data } = res;
        if (code === 200 && data) {
            this.searchCloseReasonList = data.items;
        }
    }
}
